"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TYPE = exports.LABEL_DEFAULTS = exports.BTN_DEFAULTS = void 0;
var TYPE = {
  RESET: 'reset',
  CONFIRM: 'confirm'
};
exports.TYPE = TYPE;
var BTN_DEFAULTS = {
  RESET_ID: 'resetbutton',
  CONFIRM_ID: 'closebutton',
  CONFIRM_ID_PHOTEL: 'partialHotelClosebutton',
  BORDER: 'darkGreen',
  BORDER_DISABLED: 'greyLight',
  BACKGROUND_COLOR: 'primary',
  COLOR: 'secondary',
  PADDING: '40px'
};
exports.BTN_DEFAULTS = BTN_DEFAULTS;
var LABEL_DEFAULTS = {
  TYPE: 'small',
  COLOR: 'greyDark'
};
exports.LABEL_DEFAULTS = LABEL_DEFAULTS;